
import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getCompanyPostDetails, postClient, fetchReplies, reportPost, getAllForumDetails, getForumKingUsers, getForumPopularStock } from './client/forum-details';
import { mapPaginatorData } from '../utils/data-mappers';


export const useStockPostQuery = (params) => {
    //console.log("params=====",params)
  const { data, error, isLoading } =  useQuery({
    queryKey: ["stock-posts", params.company_id],
    queryFn: async ({ pageParam = 1 }) => getCompanyPostDetails.get( { company_id:params.company_id, ...params } ),
    enabled: params.enabled && !!params.company_id, // 🔥 very important
  });

  //console.log("Forum data", data)

  return {
    records: data?.data.data,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useStockPostInfiniteQuery = ({ company_id, enabled, limit = 10 }) => {
  return useInfiniteQuery({
    queryKey: ["stock-posts", company_id, limit],
    enabled: enabled && !!company_id,

    queryFn: ({ pageParam = 1 }) =>
      getCompanyPostDetails.get({
        company_id,
        page: pageParam,
        limit
      }),

    getNextPageParam: (lastPage) =>
      lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined,
  });
};
export const useAllForumsInfiniteQuery = ({sq, limit = 10 }) => {
  return useInfiniteQuery({
    queryKey: ["stock-posts", sq, limit],
    queryFn: ({ pageParam = 1 }) =>
      getAllForumDetails.get({
        page: pageParam,
        limit,
        sq
      }),

    getNextPageParam: (lastPage) =>
      lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined,
  });
};

export const useStorePostMutation = () => {
  //return useMutation(postClient.store_post);
  /* return useMutation({
    mutationFn: (variables) => {
      return postClient.store_post(variables);
    }
  }); */
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables) => postClient.store_post(variables),

    onSuccess: (newPost) => {
      // 🔥 Reload forum after posting
      queryClient.invalidateQueries({
        queryKey: ["stock-posts"]
      });
    }
  });
  
};

export const useRepostMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (variables) => postClient.store_repost(variables),

    onSuccess: (newPost) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // 🔥 Reload forum after posting
      queryClient.invalidateQueries({
        queryKey: ["stock-posts"]
      });
    }
  });
}

/* export const useLikePostMutation = (companyId, limit=10) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (postId) => postClient.like_post(postId),

    onMutate: async (postId) => {
      await queryClient.cancelQueries({
        queryKey: ["stock-posts", companyId, limit]
      });

      const prev = queryClient.getQueryData(["stock-posts", companyId, limit]);

      queryClient.setQueryData(["stock-posts", companyId,limit], (old) => {
        if (!old) return old;

        return {
          ...old,
          pages: old.pages.map(page => {
            const newData = page.data.map(p => {
              if (p.id !== postId) return p;

              const liked = !p.user_liked;

              return {
                ...p,
                user_liked: liked,
                likes_count: liked
                  ? p.likes_count + 1
                  : p.likes_count - 1
              };
            });

            return {
              ...page,          // 🔥 important
              data: newData    // 🔥 new array reference
            };
          })
        };
      });

      return { prev };
    },

    onError: (err, postId, ctx) => {
      if (ctx?.prev) {
        queryClient.setQueryData(["stock-posts", companyId,limit], ctx.prev);
      }
    }
  });
}; */

export const useLikePostMutation = (companyId, limit = 10) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (postId) => postClient.like_post(postId),

    // Instant UI update
    onMutate: async (postId) => {
      await queryClient.cancelQueries({
        queryKey: ["stock-posts", companyId, limit]
      });

      const prev = queryClient.getQueryData(["stock-posts", companyId, limit]);

      queryClient.setQueryData(["stock-posts", companyId, limit], (old) => {
        if (!old) return old;

        return {
          ...old,
          pages: old.pages.map(page => ({
            ...page,
            data: page.data.map(p => {
              if (p.id !== postId) return p;

              const liked = !p.user_liked;

              return {
                ...p,
                user_liked: liked,
                
              };
            })
          }))
        };
      });

      return { prev };
    },

    // Sync with server truth
    /* onSuccess: (res, postId) => {
      queryClient.setQueryData(["stock-posts", companyId, limit], (old) => {
        if (!old) return old;

        

        return {
          ...old,
          pages: old.pages.map(page => ({
            ...page,
            data: page.data.map(p => {
              if (p.id !== postId) return p;

              return {
                ...p,
                user_liked: res.liked,
                likes_count: res.likes_count   // 🔥 server truth
              };
            })
          }))
        };
      });
    }, */
    onSuccess: (newPost) => {
      // 🔥 Reload forum after posting
      queryClient.invalidateQueries({
        queryKey: ["stock-posts"]
      });
    },

    onError: (err, postId, ctx) => {
      if (ctx?.prev) {
        queryClient.setQueryData(["stock-posts", companyId, limit], ctx.prev);
      }
    }
  });
};

export const useReplyMutation = (companyId, limit = 10) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (variables) => postClient.reply_post(variables),

    onSuccess: (newPost) => {
      
      // 🔥 Reload forum after posting
        queryClient.invalidateQueries({
          queryKey: ["stock-posts"]
        });
      }
  });
  //console.log('jkkjkjj', companyId)
  /* return useMutation({
    mutationFn: ({ postId, content }) =>
      postClient.reply_post({ postId, content }),

    onMutate: async ({ postId, content }) => {
      await queryClient.cancelQueries(["stock-posts", companyId, limit]);
      

      const prev = queryClient.getQueryData(["stock-posts", companyId, limit]);

      queryClient.setQueryData(["stock-posts", companyId, limit], old => {
        return {
          ...old,
          pages: old.pages.map(page => ({
            ...page,
            data: page.data.map(p => {
              if (p.id !== postId) return p;

              return {
                ...p,
                replies_count: p.replies_count + 1,
                replies: [
                  {
                    id: "temp-" + Date.now(),
                    content,
                    user: { name: "You" }
                  },
                  ...p.replies
                ]
              };
            })
          }))
        };
      });

      return { prev };
    },

    onError: (err, postId, ctx) => {
      console.log('error=====', err)
      queryClient.setQueryData(["stock-posts", companyId, limit], ctx.prev);
    },

    onSettled: () => {
      
      queryClient.invalidateQueries(["stock-posts", companyId, limit]);
    }
  }); */
};

/* export const useReplyInfiniteQuery = ({ postId, enabled }) => {
  return useInfiniteQuery({
    queryKey: ["post-replies", postId],
    enabled,
    queryFn: ({ pageParam = 1 }) =>
      fetchReplies({ postId, page: pageParam, limit: 5 }),

    getNextPageParam: (lastPage) =>
      lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined
  });
}; */
export const useReplyInfiniteQuery = ({ postId, enabled }) => {
  return useInfiniteQuery({
    queryKey: ["post-replies", postId],
    enabled: !!postId && enabled,

    queryFn: ({ pageParam = 1 }) =>
      fetchReplies({
        postId,
        page: pageParam,
        limit: 5
      }),

    getNextPageParam: (lastPage) => {
      if (!lastPage?.hasMore) return undefined;
      return lastPage.page + 1;
    }
  });
};

export const useReportPost = () => {
  return useMutation({
    mutationFn: reportPost
  });
};

export const useForumKingQuery = (params) => {
    //console.log("params=====",params)
  return useQuery({
    queryKey: ["forum-king", params],
    queryFn: async () => getForumKingUsers.get( {...params } ),
  });
};

export const useForumPopularQuery = (params) => {
    //console.log("params=====",params)
  return useQuery({
    queryKey: ["forum-popular", params],
    queryFn: async () => getForumPopularStock.get( {...params } ),
  });
};